import { Fragment, ReactNode, createContext, useCallback, useContext, useState } from 'react'

type Props = {
    children: ReactNode
}

export const ResetContainer = ({ children }: Props) => {
    const [resetNonce, setResetNonce] = useState(1)
    const handleReset = () => setResetNonce((previous) => previous + 1)

    return (
        <ResetContainerContext.Provider key={resetNonce} value={{ onReset: handleReset }}>
            {children}
        </ResetContainerContext.Provider>
    )
}

type ResetContainerContextType = {
    onReset: () => void
}

const ResetContainerContext = createContext<ResetContainerContextType>(null!)

export const useResetContainerContext = () => {
    return useContext(ResetContainerContext)
}
